import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IWasteOpenLoad} from "../../../../../../utils/interfaces/special_wasty/waste_movement/IWasteOpenLoad";


const useWasteApiGetOpenLoads = (site_id: number | undefined): UseQueryResult<IWasteOpenLoad[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IWasteOpenLoad[]> {
        try {
            const response = await get(`/api/company/${company_token}/special_wasty/waste_open_loads?site_id=${site_id}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useWasteApiGetOpenLoads", site_id],
        queryFn: () => doGet(selectedCompany?.company_token,),
        enabled: !!site_id
    })
};

export default useWasteApiGetOpenLoads